
import ActionButton from "./ActionButton";

import AddElement from "./actions/AddElement";
import ViewPages from "./actions/ViewPages";
import ViewVars from "./actions/ViewVars";
import Settings from "./actions/Settings";
import Externals from "./actions/Externals";

import { useState, useEffect } from 'react';
import { ButtonGroup, Button } from "reactstrap";
import { PlusCircleTwoTone, FunctionOutlined, FlagTwoTone, SnippetsTwoTone, SettingTwoTone } from '@ant-design/icons';

export default function ActionPanel({
    comps,
    setComps,
    page,
    setPage,
    pages,
    setPages,
    vars,
    setVars,
    externals,
    setExternals,
    parent,
    setParent,
    name,
    setName,
    dbId,
    setDbId,
    setSelectedEl,
    pageId,
    onFormSaveCallback,
    layout,
    setLayout,
    creationIndex,
    setCreationIndex
}) {

    const [view, setView] = useState('');
    const [showSaveModal, setShowSaveModal] = useState('');
    // '' => default, 'add' => add component, 'states' => state machine
    // 'externals' => externals, 'settings' => settings

    let view_render = <></>;
    if (view === 'add') {
        // debugger;
        view_render = <AddElement setSelectedEl={setSelectedEl} comps={comps} setComps={setComps} setView={setView} page={page} pageId={pageId} creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
    } else if (view === 'page') {
        view_render = <ViewPages comps={comps} setComps={setComps} setView={setView}
            page={page} setPage={setPage} pages={pages} setPages={setPages} />;
    } else if (view === 'vars') {
        view_render = <ViewVars comps={comps} setComps={setComps} setView={setView}
            vars={vars} setVars={setVars} />;
    } else if (view === 'settings') {
        view_render = <Settings comps={comps} setComps={setComps} setView={setView}
            pages={pages} setPages={setPages} vars={vars}
            externals={externals} parent={parent} name={name} setName={setName}
            dbId={dbId} setDbId={setDbId} onFormSaveCallback={onFormSaveCallback}
            layout={layout} setLayout={setLayout} creationIndex={creationIndex} setCreationIndex={setCreationIndex} />;
    } else if (view === 'externals') {
        view_render = <Externals comps={comps} setComps={setComps} setView={setView}
            pages={pages} setPages={setPages} vars={vars} setVars={setVars}
            externals={externals} setExternals={setExternals} />;
    }

    return (
        <div
            style={{ textAlign: 'center' }}
        >
            <ButtonGroup size="md">
                <Button outline title="Add element" onClick={() => {
                    if (view === '') {
                        setView('add');
                    }
                }}>
                    <PlusCircleTwoTone twoToneColor="#16a34a" />
                </Button>

                <Button outline title="Variables" onClick={() => {
                    if (view === '') {
                        setView('vars');
                    }
                }}>
                    <FunctionOutlined style={{ color: '#7c3aed' }} />
                </Button>
                <Button outline title="Flags & externals" onClick={() => {
                    if (view === '') {
                        setView('externals');
                    }
                }}>
                    <FlagTwoTone twoToneColor="#f59e0b" />
                </Button>
                <Button outline title="Pages" onClick={() => {
                    if (view === '') {
                        setView('page');
                    }
                }}>
                    <SnippetsTwoTone twoToneColor="#1777ff" />
                </Button>
                <Button outline title="Form settings" onClick={() => {
                    if (view === '') {
                        setView('settings');
                    }
                }}>
                    <SettingTwoTone twoToneColor="#475569" />
                </Button>
            </ButtonGroup>
            {view_render}
        </div>
    );

}